import SecurityDetails from './SecurityDetails';
export { SecurityDetails };
export default SecurityDetails;
